<template>
    <div class="table-container">
        <md-table class="skeleton-table">
            <md-table-row v-for="n in 5" :key="n" class="skeleton-table--row">
                <skeleton></skeleton>
            </md-table-row>
        </md-table>
    </div>
</template>

<script>
import Skeleton from './Skeleton';

export default {
    name: 'SkeletonTable',
    components: { Skeleton }
};
</script>

<style scoped lang="scss">
::v-deep tbody {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 5px;
}
</style>
